export default {
    spotId: null
}
